import { render, staticRenderFns } from "./Shoutouts.vue?vue&type=template&id=2d3d200f&"
import script from "./Shoutouts.vue?vue&type=script&lang=js&"
export * from "./Shoutouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports